export default __webpack_public_path__ + "static/media/class-activity-icon.d8033d28.png";